module.exports = __webpack_public_path__ + "img/13exp.be1fb5f7.jpg";